module.exports = __webpack_public_path__ + "img/nowater_attached.e46a8c5e.svg";